import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import shortid from 'shortid'
import {
    TextField,
    Grid
} from '@material-ui/core'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class RequestForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Хүсэлт',
            key: shortid.generate(),
            fetching: false,
            disabled: false,
            firstName: '',
            lastName: '',
            number: '',
            email: '',
            body: ''
        }
    }

    componentWillMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/requests/${id}`, { progress: true })

            this.setState({
                key: shortid.generate(),
                firstName: data.firstName,
                lastName: data.lastName,
                number: data.number,
                email: data.email,
                body: data.message
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            key,
            title,
            firstName,
            lastName,
            number,
            email,
            body
        } = this.state

        return (
            <Dashboard key={key} title={title}>
                <div>
                    <form>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                <TextField
                                    label="Нэр"
                                    value={firstName}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                />
                                <TextField
                                    label="Овог"
                                    value={lastName}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                />
                                <TextField
                                    label="И-мэйл"
                                    value={email}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                />
                                <TextField
                                    label="Утасны дугаар"
                                    value={number}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                />
                                <TextField
                                    label="Хүсэлт"
                                    value={body}
                                    variant="outlined"
                                    margin="normal"
                                    multiline
                                    rows={10}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Dashboard>
        )
    }
}

export default withStyles(styles)(RequestForm)
